import { useEffect, useRef } from 'react';

import { loadGoogleIdentityServices } from './load-google-identity-services';

type UseGoogleOneTapInput = {
  enabled: boolean;
  trackPromptRequested: () => void;
};

export function useGoogleOneTap({
  enabled,
  trackPromptRequested,
}: UseGoogleOneTapInput): void {
  const hasPrompted = useRef(false);

  useEffect(() => {
    if (!enabled || hasPrompted.current) return;

    let isActive = true;

    const load = async (): Promise<void> => {
      try {
        await loadGoogleIdentityServices();
        if (!isActive) return;

        hasPrompted.current = true;
        trackPromptRequested();
      } catch {
        // Google One Tap is an optional entry point. Existing flows stay usable.
      }
    };

    void load();

    return () => {
      isActive = false;
    };
  }, [enabled, trackPromptRequested]);
}
